/** Where a visitor reaches a person instead of a signup form. */
export const CONTACT = {
  bookingUrl: 'https://cal.com/ciprianrarau/sondely',
  email: 'hello@sondely.com',
} as const

export const MAILTO = `mailto:${CONTACT.email}`
